"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const generate_react_component_name_1 = require("./utils/generate-react-component-name");
const React_Icons_1 = require("./React-Icons");
const ReactIcon = (props) => {
    const { name, size, style = {}, className } = props;
    if (!name) {
        console.warn("Icon name is required");
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    //@ts-ignore
    const componentName = (0, generate_react_component_name_1.generateComponentName)(name);
    //@ts-ignore
    const Icon = React_Icons_1.Icons[componentName];
    if (!Icon)
        return (0, jsx_runtime_1.jsx)("div", {});
    // return <div>Icon should be rendering</div>;
    return (0, jsx_runtime_1.jsx)(Icon, { style: style, size: size, className: className });
};
exports.ReactIcon = ReactIcon;
